import { createContext, useCallback, useContext, useRef } from 'react';

type RegisterDragElement = undefined | ((element: HTMLButtonElement | null) => void);

const RegisterDragElementContext = createContext<RegisterDragElement>(undefined);

export const useDragElement = () => {
  const ref = useRef<HTMLButtonElement | null>(null);
  const registerDragElement = useContext(RegisterDragElementContext);

  const setRef = useCallback(
    (element: HTMLButtonElement | null) => {
      registerDragElement?.(element);
      ref.current = element;
    },
    [ref, registerDragElement]
  );

  return [setRef, ref] as const;
};

export const RegisterDragElementProvider = RegisterDragElementContext.Provider;
